import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["format", "pdfSlug", "freeSlug", "pdfHint", "inAppHint"]

  connect() {
    this.toggle()
  }

  toggle() {
    const isPdf = this.formatTarget.value === "pdf"
    this.pdfSlugTarget.hidden = !isPdf
    this.pdfSlugTarget.disabled = !isPdf
    this.freeSlugTarget.hidden = isPdf
    this.freeSlugTarget.disabled = isPdf
    if (this.hasPdfHintTarget)   this.pdfHintTarget.hidden = !isPdf
    if (this.hasInAppHintTarget) this.inAppHintTarget.hidden = isPdf
  }
}
